import script from "./old-user.vue?vue&type=script&lang=ts&setup=true"
export * from "./old-user.vue?vue&type=script&lang=ts&setup=true"

import "./old-user.vue?vue&type=style&index=0&id=68778acf&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68778acf"]])

export default __exports__